<template>
    <div class="loading">
      <b-modal v-model="dialog"
        size="sm" 
        body-bg-variant="info" body-text-variant="white" 
        hide-header hide-footer
        no-close-on-backdrop no-close-on-esc 
        style="border-radius: 10px;" 
        centered                   
      >      
        <div class="d-block text-center">
            <b-spinner small type="grow"/>
            {{ txt }}
        </div>

        <!-- <b-button variant="primary" disabled>
            <b-spinner small type="grow"/>
            Loading...
        </b-button>   -->
      </b-modal>      
    </div>
</template>

<script>
export default {
  props: {
    txt: { type: String, default: "Cargando.." },
    //bind: { type: Object, default: function() { return this.$cfg.ctrls.loading; }}
  },
  data() {
      return {
        dialog: false,
      }
  },
  methods: {
      show(ok=true,txt='') {
          this.txt=(txt==='' ? 'Cargando..' : txt);
          this.dialog=ok;
      }
  },
  computed: {
    
  },

};
</script>
